module.exports = __webpack_public_path__ + "static/media/light-background-3x.79286a8e.jpg";